import React, { useState, useEffect } from "react";
import "./navBar.scss";
import { AiFillCloseCircle } from "react-icons/ai";
import { TbGridDots } from "react-icons/tb";
import { Link } from "react-router-dom";
import { FiPhoneCall, FiMail } from "react-icons/fi";
import { FaShieldAlt } from "react-icons/fa";
import { BsGear } from "react-icons/bs";
import logo from "../../Assets/Logo.png";
import { fetchCategories } from "../../services/tripServices";

const Navbar = () => {
  const [active, setActive] = useState("navBar"); // controls mobile nav open/close
  const [openExp, setOpenExp] = useState(false);
  const [openTreks, setOpenTreks] = useState(false);
  const [openTours, setOpenTours] = useState(false);

  const [expeditionsCategories, setExpeditionsCategories] = useState([]);
  const [treksCategories, setTreksCategories] = useState([]);
  const [toursCategories, setToursCategories] = useState([]);

  useEffect(() => {
    fetchCategories('expeditions').then((data) => {
      setExpeditionsCategories(data);
    }).catch((error) => {
      console.error("Error fetching expeditions categories:", error);
    });

    fetchCategories('treks').then((data) => {
      setTreksCategories(data);
    }).catch((error) => {
      console.error("Error fetching treks categories:", error);
    });
    fetchCategories('tours').then((data) => {
      setToursCategories(data);
    }).catch((error) => {
      console.error("Error fetching tours categories:", error);
    });
  }, []);

  const showNav = () => setActive("navBar activeNavbar");
  const removeNavbar = () => {
    setActive("navBar");
    setOpenExp(false);
    setOpenTreks(false);
    setOpenTours(false);
  };

  // Toggle dropdown by name (only on small screens)
  const toggleDropdown = (name) => {
    if (window.innerWidth > 960) return; // on desktop we rely on hover
    if (name === "exp") {
      setOpenExp((s) => !s);
      setOpenTreks(false);
      setOpenTours(false);
    } else if (name === "treks") {
      setOpenTreks((s) => !s);
      setOpenExp(false);
      setOpenTours(false);
    } else if (name === "tours") {
      setOpenTours((s) => !s);
      setOpenExp(false);
      setOpenTreks(false);
    }
  };

  // Close dropdowns when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960) {
        setOpenExp(false);
        setOpenTreks(false);
        setOpenTours(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem('user'))

  return (
    <section className="navBarSection">
      {/* Top Bar */}
      <div className="topBar flex">
        <div className="topItem">
          <FiPhoneCall className="icon" /> <span>+92 349 158 9717</span>
        </div>
        <div className="topItem">
          <FiMail className="icon" />
          <a href="mailto:worldadventuretours@gmail.com">worldadventuretours@gmail.com</a>
        </div>
        <div className="topItem">
          <BsGear className="icon" /> <span>10 Years of Excellence</span>
        </div>
        <div className="topItem">
          <FaShieldAlt className="icon" /> <span>Govt Licence: 021</span>
        </div>
      </div>

      {/* Navbar */}
      <header className="header flex">
        <div className="logo">
          <img src={logo} alt="World Adventure Tours Logo" className="logo-image" />
        </div>
        <div className="logoDiv">
          <a href="#" className="logo flex">
            <h1>World Adventures Tours</h1>
          </a>
        </div>

        <div className={active}>
          <ul className="navLists flex">
            <li className="navItem">
              <Link to="/" className="navLink" onClick={removeNavbar}>
                Home
              </Link>
            </li>

            <li className="navItem">
              <Link to="/About" className="navLink" onClick={removeNavbar}>
                About
              </Link>
            </li>

            {/* Expeditions dropdown */}
            <li className={`navItem ${openExp ? "open" : ""}`}>
              <div
                className="navLink dropdownToggle"
                onClick={() => toggleDropdown("exp")}
              >
                <span>Expeditions</span>
                {/* <span className="caret">▾</span> */}
              </div>

              <ul className="dropdown">
                {expeditionsCategories.map((cat, index) => (
                  <li key={index}>
                    <Link to={`/category/${cat.name}-${cat.type}`} onClick={removeNavbar}>
                      {cat.name}
                    </Link>
                  </li>
                ))}

              </ul>
            </li>

            {/* Treks dropdown */}
            <li className={`navItem ${openTreks ? "open" : ""}`}>
              <div
                className="navLink dropdownToggle"
                onClick={() => toggleDropdown("treks")}
              >
                <span>Treks</span>
                {/* <span className="caret">▾</span> */}
              </div>

              <ul className="dropdown">
                {treksCategories.map((cat, index) => (
                  <li key={index}>
                    <Link to={`/category/${cat.name}-${cat.type}`} onClick={removeNavbar}>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {/* Tours dropdown */}
            <li className={`navItem ${openTours ? "open" : ""}`}>
              <div
                className="navLink dropdownToggle"
                onClick={() => toggleDropdown("tours")}
              >
                <span>Tours</span>
                {/* <span className="caret">▾</span> */}
              </div>

              <ul className="dropdown">
                {toursCategories.map((cat, index) => (
                  <li key={index}>
                    <Link to={`/category/${cat.name}-${cat.type}`} onClick={removeNavbar}>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li className="navItem">
              <Link to="/Contact" className="navLink" onClick={removeNavbar}>
                Contact
              </Link>
            </li>

            <li className="navItem">
              <Link to="/Blogs" className="navLink" onClick={removeNavbar}>
                Blogs
              </Link>
            </li>

            {
              user ? user.role === "admin" ?
                (
                  <button className="btn">
                    <Link to="/admin" className="navLink" onClick={removeNavbar}>
                      Admin Panel
                    </Link>
                  </button>
                ) : (
                  <button className="btn">
                    <Link to="/my-bookings" className="navLink" onClick={removeNavbar}>
                      My Bookings
                    </Link>
                  </button>

                ) : (
                <button className="btn">
                  <Link to="/login?returnTo=/" className="navLink" onClick={removeNavbar}>
                    Login
                  </Link>
                </button>
              )
            }
          </ul>

          <div onClick={removeNavbar} className="closeNavbar">
            <AiFillCloseCircle className="icon" />
          </div>
        </div>

        <div onClick={showNav} className="toggleNavbar">
          <TbGridDots className="icon" />
        </div>
      </header>
    </section>
  );
};

export default Navbar;
